import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const PaperclipChip: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="32"
    height="28"
    viewBox="0 0 32 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="28" rx="14" fill="#F8F9FA" fillOpacity="0.8" />
    <path
      d="M22.5326 13.5933L16.317 19.8611C16.0759 20.1068 15.7881 20.302 15.4707 20.4352C15.1532 20.5685 14.8123 20.6371 14.468 20.6371C14.1237 20.6371 13.7829 20.5685 13.4654 20.4352C13.1479 20.302 12.8602 20.1068 12.6191 19.8611L10.7596 17.9703C10.2728 17.4759 10 16.8099 10 16.1161C10 15.4223 10.2728 14.7563 10.7596 14.2619L17.3826 7.618C17.5768 7.42218 17.8079 7.26675 18.0625 7.16068C18.3171 7.05461 18.5901 7 18.8659 7C19.1417 7 19.4148 7.05461 19.6694 7.16068C19.924 7.26675 20.1551 7.42218 20.3493 7.618L21.091 8.35969C21.2869 8.55391 21.4423 8.78499 21.5483 9.03958C21.6544 9.29417 21.709 9.56726 21.709 9.84306C21.709 10.1189 21.6544 10.392 21.5483 10.6465C21.4423 10.9011 21.2869 11.1322 21.091 11.3264L15.2202 17.2181C15.1231 17.3161 15.0075 17.3938 14.8802 17.4468C14.7529 17.4999 14.6164 17.5271 14.4785 17.5271C14.3406 17.5271 14.204 17.4999 14.0767 17.4468C13.9495 17.3938 13.8339 17.3161 13.7368 17.2181L13.3712 16.8421C13.2733 16.745 13.1956 16.6294 13.1425 16.5021C13.0895 16.3749 13.0622 16.2383 13.0622 16.1004C13.0622 15.9625 13.0895 15.826 13.1425 15.6987C13.1956 15.5714 13.2733 15.4558 13.3712 15.3587L17.3094 11.4518"
      stroke="#292C4B"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
